module.exports = __webpack_public_path__ + "static/habla_company-d6f96853d09354dd2b56a4cea87fc260.svg";